import { axios, base } from '../http';

export const getExamRoomListPage = (params) => {
  return axios.get(`${base}/api/ExamRoom/get`, { params: params });
};
//编辑考场

export const editExamRoom = (params) => {
  return axios.put(`${base}/api/ExamRoom/put`, params);
};
//新增考场

export const addExamRoom = (params) => {
  return axios.post(`${base}/api/ExamRoom/post`, params);
};
//删除考场

export const deleteExamRoom = (params) => {
  return axios.delete(`${base}/api/ExamRoom/Delete`, { params: params });
};

//获取菜品分类

export const getExamList = (params) => {
  return axios.get(`${base}/api/Exam/get`, { params: params });
};
//编辑考试

export const updateExam = (params) => {
  return axios.put(`${base}/api/Exam/put`, params);
};
//新增考试

export const addExam = (params) => {
  return axios.post(`${base}/api/Exam/post`, params);
};
//删除考试

export const deleteExam = (params) => {
  return axios.delete(`${base}/api/Exam/Delete`, { params: params });
};

//强制删除考试（含关联数据，需超密授权）

export const forceDeleteExam = (params) => {
  return axios.post(`${base}/api/Exam/ForceDelete`, params);
};

// 获取考试场次列表

export const getExamSessionList = (params) => {
  return axios.get(`${base}/api/ExamSession/get`, { params: params });
};

// 新增考试场次

export const addExamSession = (params) => {
  return axios.post(`${base}/api/ExamSession/post`, params);
};

// 编辑考试场次

export const updateExamSession = (params) => {
  return axios.put(`${base}/api/ExamSession/put`, params);
};

// 删除考试场次

export const deleteExamSession = (params) => {
  return axios.delete(`${base}/api/ExamSession/Delete`, { params: params });
};

// 获取考试场次的考场编排列表

export const getExamSessionRooms = (params) => {
  return axios.get(`${base}/api/ExamSessionRoom/GetRooms`, { params: params });
};

// 获取考试场次可用的考场列表

export const getAvailableExamRooms = (params) => {
  return axios.get(`${base}/api/ExamSessionRoom/GetAvailableRooms`, {
    params: params,
  });
};

// 分配考场

export const assignExamSessionRooms = (params) => {
  return axios.post(`${base}/api/ExamSessionRoom/AssignRoom`, params);
};

// 移除考场分配

export const removeExamSessionRoom = (params) => {
  return axios.delete(`${base}/api/ExamSessionRoom/RemoveRoom`, {
    params: params,
  });
};

// 获取监考老师列表

export const getExamInvigilatorList = (params) => {
  return axios.get(`${base}/api/ExamInvigilator/GetList`, { params: params });
};

// 获取可用的监考老师

export const getAvailableInvigilators = (params) => {
  return axios.get(`${base}/api/ExamInvigilator/GetAvailableTeachers`, {
    params: params,
  });
};

// 分配监考老师

export const assignInvigilator = (params) => {
  return axios.post(`${base}/api/ExamInvigilator/Assign`, params);
};

// 移除监考老师

export const removeInvigilator = (params) => {
  return axios.delete(`${base}/api/ExamInvigilator/Remove`, { params: params });
};

// 获取指定考试和考场下的所有考生安排

export const getExamStudentList = (params) => {
  return axios.get(`${base}/api/ExamStudent/GetList`, { params: params });
};

// 获取某个考试中未被安排的可用考生

export const getAvailableStudents = (params) => {
  return axios.get(`${base}/api/ExamStudent/GetAvailableStudents`, {
    params: params,
  });
};

// 分配考生到考场

export const assignExamStudents = (params) => {
  return axios.post(`${base}/api/ExamStudent/Assign`, params);
};

// 移除考生安排

export const removeExamStudent = (params) => {
  return axios.delete(`${base}/api/ExamStudent/Remove`, { params: params });
};
// 编辑/更新分配好的考生信息（如修改座位号）

export const updateExamStudent = (params) => {
  return axios.put(`${base}/api/ExamStudent/Edit`, params);
};

export const downloadStudentTemplate = (params) => {
  return `${base}/api/ExamStudent/DownloadTemplate`;
};

export const importExamStudentList = (params) => {
  return axios.post(`${base}/api/ExamStudent/Import`, params);
};

export const getArrangedStudentsByExamId = (params) => {
  return axios.get(`${base}/api/ExamStudent/GetArrangedStudentsByExamId`, {
    params: params,
  });
};

export const getExamSignInList = (params) => {
  return axios.get(`${base}/api/ExamSignIn/List`, { params: params });
};

export const manualExamSignIn = (params) => {
  return axios.post(`${base}/api/ExamSignIn/Manual`, params);
};

export const revokeExamSignIn = (params) => {
  return axios.post(`${base}/api/ExamSignIn/Revoke`, params);
};

export const exportExamSignIn = (params) => {
  return axios.get(`${base}/api/ExamSignIn/Export`, {
    params: params,
    responseType: "blob",
  });
};

export const getCplateExamList = (params) => {
  return axios.get(`${base}/api/cplate/exam/list`, { params: params });
};

export const getCplateExamRoomBoard = (params) => {
  return axios.get(`${base}/api/cplate/exam/roomboard`, { params: params });
};

export const cplateExamSignIn = (params) => {
  return axios.post(`${base}/api/cplate/exam/signin`, params);
};

export const cplateManualExamSignIn = (params) => {
  return axios.post(`${base}/api/cplate/exam/manualsignin`, params);
};

export const cplateRevokeExamSignIn = (params) => {
  return axios.delete(`${base}/api/cplate/exam/revokesignin`, { params: params });
};

export const cplateInvigilatorSignIn = (params) => {
  return axios.post(`${base}/api/cplate/exam/invigilatorsignin`, params);
};

//导出分餐段消费明�?
